import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";

export function ConvertButtonStep() {
  return (
    <div>
      <Heading4 elementType="h3" className="mb-2">
        Convert Button
      </Heading4>
      <NormalText elementType="p" className="text-sm">
        Click here to convert your vocal.
      </NormalText>
    </div>
  );
}
